import React from 'react';
import {Disclosure, RadioGroup, Switch} from '@headlessui/react';
import clsx from 'clsx';
import * as R from 'ramda';
import {Link} from 'components/Link';
import {useLoaderData, useMatches} from '@remix-run/react';

//domains
import {loader} from '~/routes/($lang)/collections/$collectionHandle';
import {
  findNestedLevel,
  findSiblings,
  gidExists,
  findImmediateChildren,
  SanityCollectionLevel,
} from 'domains/collections';

export default function RelatedCollections() {
  const {collectionsTranslated, relatedCollections, collection, translation} =
    useLoaderData<typeof loader>();
  const [root] = useMatches();
  const menu = root?.data?.menu as any;
  const allMegaMenus = menu?.filter((m: any) => m._type === 'linkMegaMenu');
  const allCollectionsInHierarchy = allMegaMenus
    .map((m: any) => {
      const col1Links = m?.col_1_links?.links?.map((l: any) => ({
        title: l?.title,
        gid: l?.reference?.store?.gid,
      }));
      const col2Links = m?.col_2_links?.links?.map((l: any) => ({
        title: l?.title,
        gid: l?.reference?.store?.gid,
      }));
      const col3Links = m?.col_3_links?.links?.map((l: any) => ({
        title: l?.title,
        gid: l?.reference?.store?.gid,
      }));
      const col4Links = m?.col_4_links?.links?.map((l: any) => ({
        title: l?.title,
        gid: l?.reference?.store?.gid,
      }));
      const col5Links = m?.col_5_links?.links?.map((l: any) => ({
        title: l?.title,
        gid: l?.reference?.store?.gid,
      }));

      return col1Links.concat(col2Links, col3Links, col4Links, col5Links);
    })
    ?.flat();

  return (
    <Disclosure defaultOpen={true}>
      {({open}) => (
        <>
          <Disclosure.Button className="flex w-full items-center justify-between pt-2 pb-4 text-left">
            <div className="">
              {translation.filter['Related Collections'] ??
                'Related Collections'}
            </div>
            {open ? (
              <svg
                width="13"
                height="3"
                viewBox="0 0 13 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0851 0.659999V2.816H0.913063V0.659999H12.0851Z"
                  fill="black"
                />
              </svg>
            ) : (
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.31536 0.611999V6.688H0.37936V8.844H6.31536V14.892H8.69536V8.844H14.6594V6.688H8.69536V0.611999H6.31536Z"
                  fill="black"
                />
              </svg>
            )}
          </Disclosure.Button>
          <Disclosure.Panel
            className={clsx([
              'text-gray-500 my-2 md:max-h-[400px] md:overflow-scroll',
            ])}
          >
            <div className="grid gap-3">
              {relatedCollections
                ? relatedCollections
                    // .filter(
                    //   (c) => c.this_collection.store.gid !== collection.id,
                    // )
                    .map((c) => {
                      const title =
                        allCollectionsInHierarchy.find(
                          (h: {gid: string; title: string}) =>
                            h?.gid === c?.this_collection?.store?.gid,
                        )?.title ??
                        collectionsTranslated?.find(
                          (t) => t.id === c?.this_collection?.store?.gid,
                        )?.title ??
                        c?.this_collection.store?.title;
                      return (
                        <div className="" key={c?._key}>
                          <Link
                            to={`/collections/${c?.this_collection?.store?.slug?.current}`}
                            className={clsx(
                              'capitalize font-bold',
                              c?.this_collection?.store?.gid ===
                                collection?.id && 'text-hk-orange',
                            )}
                          >
                            {title}
                          </Link>

                          {c?.associated_collections &&
                            c?.associated_collections[0]?.collections && (
                              <ul className="grid gap-3 mt-3">
                                {c.associated_collections[0]?.collections?.map(
                                  (ac) => {
                                    return (
                                      <div className="pl-5" key={ac._key}>
                                        <Link
                                          to={`/collections/${ac.this_collection.store?.slug?.current}`}
                                          className={clsx(
                                            'font-normal capitalize underline',
                                            ac?.this_collection?.store?.gid ===
                                              collection?.id &&
                                              'text-hk-orange',
                                          )}
                                        >
                                          {
                                            collectionsTranslated?.find(
                                              (t) =>
                                                t.id ===
                                                ac?.this_collection?.store?.gid,
                                            )?.title
                                          }
                                        </Link>
                                        {ac.associated_collections &&
                                          ac.associated_collections[0]
                                            ?.collections && (
                                            <ul className="grid gap-3 mt-3">
                                              {ac.associated_collections[0]?.collections?.map(
                                                (ac3) => {
                                                  return (
                                                    <div
                                                      className="pl-5"
                                                      key={ac3._key}
                                                    >
                                                      <Link
                                                        to={`/collections/${ac3.this_collection.store?.slug?.current}`}
                                                        className={clsx(
                                                          'font-light capitalize',
                                                          ac3?.this_collection
                                                            ?.store?.gid ===
                                                            collection?.id &&
                                                            'text-hk-orange',
                                                        )}
                                                      >
                                                        {
                                                          collectionsTranslated?.find(
                                                            (t) =>
                                                              t.id ===
                                                              ac3
                                                                ?.this_collection
                                                                ?.store?.gid,
                                                          )?.title
                                                        }
                                                      </Link>
                                                    </div>
                                                  );
                                                },
                                              )}
                                            </ul>
                                          )}
                                      </div>
                                    );
                                  },
                                )}
                              </ul>
                            )}
                        </div>
                      );
                    })
                : null}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
